import { DisableFilterWhen } from "hooks/useOmnisearchDatagrid";

/**
 * Whether `rule` disables its filter, given filter values keyed as `parseOmnisearch` returns them.
 * The disabling field must hold a scalar (string or boolean), such as a boolean or select filter.
 */
export function isDisabledByRule(
  rule: DisableFilterWhen | undefined,
  values: Record<string, unknown>
): boolean {
  if (!rule) return false;
  return String(values[rule.field]) === String(rule.value);
}
